<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		aria-hidden="true"
	>
		<path
			d="M8.16634 1.16602H3.49967C3.19026 1.16602 2.89351 1.28893 2.67472 1.50772C2.45592 1.72652 2.33301 2.02326 2.33301 2.33268V11.666C2.33301 11.9754 2.45592 12.2722 2.67472 12.491C2.89351 12.7098 3.19026 12.8327 3.49967 12.8327H10.4997C10.8091 12.8327 11.1058 12.7098 11.3246 12.491C11.5434 12.2722 11.6663 11.9754 11.6663 11.666V4.66602L8.16634 1.16602Z"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.16699 1.16602V4.66602H11.667"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.33366 7.58398H4.66699"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.33366 9.91602H4.66699"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.83366 5.25H5.25033H4.66699"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'SaveAsPdfIcon',
}
</script>
